import { RspndrCallListItem, RspndrCallType } from '@hakimo-ui/hakimo/types';

export async function generateHMAC(apiKey: string, apiSecret: string) {
  const currentTimeInSeconds = Math.floor(Date.now() / 1000);

  const input = apiKey + apiSecret + currentTimeInSeconds;

  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hashHex;
}

export const getCallList = (): RspndrCallListItem[] => {
  return [
    {
      order: 1,
      name: 'MAIN',
      type: RspndrCallType.MOBILE,
      number: '925-515-3200',
    },
    {
      order: 2,
      name: 'EMERGENCY',
      type: RspndrCallType.MOBILE,
      number: '925-393-2909',
    },
  ];
};
